import { render, staticRenderFns } from "./PhoneForm.vue?vue&type=template&id=12944597"
import script from "./PhoneForm.vue?vue&type=script&lang=js"
export * from "./PhoneForm.vue?vue&type=script&lang=js"
import style0 from "./PhoneForm.vue?vue&type=style&index=0&id=12944597&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports